import { isRSAA, isValidRSAA, RSAA } from 'redux-api-middleware';

const createAuthHeaderMiddleware = (getToken) => (store) => (next) => (action) => {
	if (!isRSAA(action)) {
		return next(action);
	}

	if (
		isValidRSAA(action) &&
		action[RSAA].types[0] &&
		action[RSAA].types[0].meta &&
		action[RSAA].types[0].meta.noAuthApiHeaders
	) {
		return next(action);
	}

	const token = getToken(store.getState(), action);

	const nextAction = {
		[RSAA]: {
			...action[RSAA],
			headers: {
				Authorization: `Bearer ${token}`,
				...action[RSAA].headers,
			},
		},
	};

	return next(nextAction);
};

export default createAuthHeaderMiddleware;
